module.exports = __webpack_public_path__ + "static/media/popup2.0472073a.webp";